import { defineMessages } from 'react-intl';

export default defineMessages({
  titleDialog: {
    id: 'invoice.fee_note_dialog.title',
  },
  subTitleDialog: {
    id: 'invoice.fee_note_dialog.sub_title',
  },
  generateFeeNoteTitle: {
    id: 'invoice.fee_note_dialog.generate_fee_note.title',
  },
  doNotGenerateFeeNoteTitle: {
    id: 'invoice.fee_note_dialog.do_not_generate_fee_note.title',
  },
  confirm: {
    id: 'fee_note.confirm_btn',
  },
  cancel: {
    id: 'cancel_btn',
  },
  dialogInfoTitle: {
    id: 'invoice.dialog_info.title',
  },
  dialogInfoSubTitle: {
    id: 'invoice.dialog_info.sub_title',
  },
  dialogInfoTitleForm: {
    id: 'invoice.dialog_info.title_form',
  },
  invoiceNumberField: {
    id: 'invoice.dialog_info.field_invoice_number',
  },
  invoiceDateField: {
    id: 'invoice.dialog_info.field_invoice_date',
  },
  invoiceReceptionDateField: {
    id: 'invoice.dialog_info.field_invoice_reception_date',
  },
  dialogInfoManagerSubTitle: {
    id: 'invoice.dialog_info_manager.sub_title',
  },
  errorInvoiceDateIntervenant: {
    id: 'invoice.dialog_info.limit_invoice_date.intervenant.error',
  },
  warningInvoiceDateManager: {
    id: 'invoice.dialog_info.limit_invoice_date.manager_warning',
  },
  dialogInfoSubUpdateTitle: {
    id: 'invoice.dialog_info_update.sub_title',
  },
  firmReference: {
    id: 'fee_note.firm_reference',
  },
});
